export default "__VITE_ASSET__y1cGEMSf__"